import { Controller } from "@hotwired/stimulus"

// Poetry's toaster is data-turbo-permanent. Flash markup rendered inside
// it is kept from the PREVIOUS page, so after a Turbo redirect the new
// flash never appears. Stamp each flash toast into the live toaster from
// a turbo-temporary host. On cross-URL visits Turbo restores the
// permanent toaster after new controllers connect — retry until it exists.
export default class extends Controller {
  connect() {
    this.boundStamp = () => this.stamp()
    this.stamp()
    if (!this.element.isConnected) return

    this.raf = requestAnimationFrame(this.boundStamp)
    document.addEventListener("turbo:render", this.boundStamp)
    document.addEventListener("turbo:load", this.boundStamp)
  }

  disconnect() {
    if (this.raf) cancelAnimationFrame(this.raf)
    document.removeEventListener("turbo:render", this.boundStamp)
    document.removeEventListener("turbo:load", this.boundStamp)
  }

  stamp() {
    if (!this.element.isConnected) return

    const toaster = document.getElementById("poetry-toaster")
    if (!toaster) return

    this.element.querySelectorAll("template").forEach((template) => {
      const fragment = template.content.cloneNode(true)
      fragment.querySelectorAll("[data-slot='toast']").forEach((toast) => {
        toast.setAttribute("data-turbo-temporary", "")
      })
      toaster.append(fragment)
    })
    this.element.remove()
  }
}
